import type { AvailableModelsResponse, Project, ProjectExtra } from '@/types';

import { request } from './client';

interface CreateProjectPayload {
  title: string;
  description?: string;
  created_by?: string;
  extra?: ProjectExtra;
}

interface UpdateProjectPayload {
  title?: string;
  description?: string;
  extra?: ProjectExtra;
}

export const ProjectApi = {
  listProjects(): Promise<Project[]> {
    return request<Project[]>('/projects');
  },
  getProject(projectKey: string): Promise<Project> {
    return request<Project>(`/projects/${projectKey}`);
  },
  getModels(): Promise<AvailableModelsResponse> {
    return request<AvailableModelsResponse>('/projects/models');
  },
  createProject(payload: CreateProjectPayload): Promise<Project> {
    return request<Project>('/projects', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
  updateProject(projectKey: string, payload: UpdateProjectPayload): Promise<Project> {
    return request<Project>(`/projects/${projectKey}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },
  deleteProject(projectKey: string): Promise<void> {
    return request<void>(`/projects/${projectKey}`, {
      method: 'DELETE',
    });
  },
};
